import React, { useEffect, useState } from 'react';
import { Container, Table, Badge, Button, Spinner, Card } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { ordersAPI } from '../services/api';
import { toast } from 'react-toastify';

const MyOrders = () => {
  const [orders, setOrders] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    fetchOrders();
  }, []);

  const fetchOrders = async () => {
    try {
      const response = await ordersAPI.getMyOrders();
      setOrders(response.data.orders);
    } catch (error) {
      toast.error('Failed to load orders');
    } finally {
      setIsLoading(false);
    }
  };

  const getStatusBadge = (status) => {
    const variants = {
      completed: 'success',
      pending: 'warning',
      failed: 'danger',
      refunded: 'info',
    };
    return <Badge bg={variants[status] || 'secondary'}>{status.toUpperCase()}</Badge>;
  };

  if (isLoading) {
    return (
      <Container className="my-5 text-center">
        <Spinner animation="border" variant="primary" />
      </Container>
    );
  }

  return (
    <Container className="my-5">
      <h1 className="mb-4">My Orders</h1>

      {orders.length === 0 ? (
        <Card>
          <Card.Body className="text-center py-5">
            <h4>No orders yet</h4>
            <p className="text-muted">Start shopping to see your orders here</p>
            <Button as={Link} to="/products" variant="primary">
              Browse Products
            </Button>
          </Card.Body>
        </Card>
      ) : (
        <Card>
          <Card.Body>
            <Table responsive hover>
              <thead>
                <tr>
                  <th>Order ID</th>
                  <th>Date</th>
                  <th>Items</th>
                  <th>Total</th>
                  <th>Status</th>
                  <th>Delivery</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {orders.map((order) => (
                  <tr key={order._id}>
                    <td>
                      <small className="font-monospace">{order._id.slice(-8)}</small>
                    </td>
                    <td>{new Date(order.createdAt).toLocaleDateString()}</td>
                    <td>{order.orderItems.length} item(s)</td>
                    <td>₹{order.totalAmount}</td>
                    <td>{getStatusBadge(order.paymentStatus)}</td>
                    <td>
                      {order.emailSent && <Badge bg="success" className="me-1">Email</Badge>}
                      {order.whatsappSent && <Badge bg="success">WhatsApp</Badge>}
                      {!order.emailSent && !order.whatsappSent && (
                        <Badge bg="secondary">Pending</Badge>
                      )}
                    </td>
                    <td>
                      <Button
                        as={Link}
                        to={`/orders/${order._id}`}
                        variant="outline-primary"
                        size="sm"
                      >
                        View Details
                      </Button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </Card.Body>
        </Card>
      )}
    </Container>
  );
};

export default MyOrders;
